import React from 'react';
import PropTypes from 'prop-types';

import { StickyContainer } from '@sparefoot/react-core';

import { withSearchHandler } from 'decorators';
import { Paragraph } from 'components/core/Typography';
import { Section, Container, Row, Column } from 'components/core/Page';
import { SearchBox } from 'components/search/SearchBox';

import MapPin from 'components/svg/MapPin';

import './StickySearch.scss';

export const enhance = withSearchHandler;

export const StickySearch = ({ triggerId, handleSearch }) => {
	return (
		<StickyContainer triggerId={triggerId}>
			<Section className="sticky-search-bar">
				<Container>
					<Row>
						<Column>
							<div className="sticky-search">
								<Paragraph
									weight="extraBold"
									color="white"
									size="mediumLarge"
								>
									Find Storage Units Near You
								</Paragraph>
								<SearchBox
									inputLabel="Enter Zip Code or City Name"
									onSearch={handleSearch}
									icon={<MapPin fill="gray" />}
									withSearchType={false}
									hideAutocompleteOnScroll
									useBrowserLocation
								/>
							</div>
						</Column>
					</Row>
				</Container>
			</Section>
		</StickyContainer>
	);
};

StickySearch.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	triggerId: PropTypes.string,
};

export default enhance(StickySearch);
